export default class PersistentConnector {
    constructor(reconnectHandler, {
        maxReconnectAttempts = 10,
        connectionRetryTimeRate = 2,
        baseReconnectTimeout = 5000,
        name = 'Unnamed Connection'
    } = {}) {
        this.reconnectHandler = reconnectHandler;
        this.maxReconnectAttempts = maxReconnectAttempts;
        this.connectionRetryTimeRate = connectionRetryTimeRate;
        this.baseReconnectTimeout = baseReconnectTimeout;
        this.name = name;
        this.reset();
    }

    reset() {
        this.reconnectTimeout = null;
        this.reconnectAttempts = 0;
    }

    recover() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts += 1;

            if (this.reconnectTimeout === null) {
                this.reconnectTimeout = this.baseReconnectTimeout;
            }
            console.log(`Attempt ${this.reconnectAttempts} to recover ${this.name} connection. Next try after ${this.reconnectTimeout}ms timeout`);

            setTimeout(() => {
                this.reconnectTimeout *= this.connectionRetryTimeRate;
                this.reconnectHandler();
            }, this.reconnectTimeout);
        } else {
            console.log(`Max reconnection attempts count for ${this.name} was reached`);
        }
    }

    onConnect() {
        this.reset();
    }
}



// WEBPACK FOOTER //
// ./app/general/js/persistent-connector.js